
const pilotItems = [
  { number: '01', text: 'Build an NPI-targeted audience' },
  { number: '02', text: 'Launch branded video or display campaigns' },
  {
    number: '03',
    text: 'Deliver engagement reports weekly with contact info, specialty, and activity',
  },
  {
    number: '04',
    text: 'Measure outcomes such as cost per lead, time-to-fill, and downstream conversion',
  },
];

const PilotCard = ({ number, text }) => {
  return (
    <div className="bg-white rounded-lg p-4 shadow-md flex items-center justify-start gap-[20px] w-[320px] md:w-full lg:max-w-[570px]">
      <div className="bg-[#2F72BD] text-[15px] text-white rounded-full w-[48px] h-[48px] flex-shrink-0 flex items-center justify-center font-bold">
        {number}
      </div>
      <p className="text-sm md:text-[24px]">{text}</p>
    </div>
  );
};

export const PilotSection = () => {
  return (
    <div className="py-[40px] px-[5%] lg:py-[80px] my-[40px] lg:my-[80px] w-full flex flex-col gap-[20px] items-center justify-center xl:justify-between xl:flex-row xl:space-x-8 lg:max-w-[1280px] lg:mx-auto">
      <div className="p-0 sm:p-4 max-w-[600px] flex flex-col mx-[20px]">
        <p className="text-[#7BD825] font-semibold mb-1 md:mb-2 text-sm sm:text-base">
          How It Works
        </p>
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 lg:mb-6 leading-tight">
          Getting Started: A 30-Day Pilot
        </h1>
        <p className="text-gray-600 text-[23px]] md:text-lg mb-6 lg:mb-8">
          Hospitals can begin by identifying 1-2 hard-to-fill roles this initial
          pilot can then serve as a proof point for expanding to other
          departments or roles and demonstrating the value of modernizing
          passive outreach.
        </p>
        <a className="btn btn-secondary btn-lg" target="_blank" href='https://meetings.hubspot.com/kgreves?uuid=f329a8a8-351c-4955-85e5-cb6732ebc25f' rel="noreferrer">
          Schedule a Strategy Call
        </a>
      </div>

      <div className="flex flex-col justify-center items-center w-full bg-[#2F72BD] rounded-lg p-6 lg:p-8 xl:absolute xl:mt-[10%] right-0 xl:max-w-[478px]">
        <div className="flex flex-col justify-center gap-[5px] w-full items-center xl:translate-x-[-100px]">
          {pilotItems.map((item) => (
            <PilotCard number={item.number} text={item.text} />
          ))}
        </div>
      </div>
    </div>
  );
};
